export function getFolderIdFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const folderIdFromURL = urlParams.get("folderID") ?? "";
  const folderId = parseInt(folderIdFromURL);
  return Number.isNaN(folderId) ? undefined : folderId;
}

export function getFolderNameFromURL() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const folderName = params.get('folderName');
  return folderName;
}

export function getDataFromURL(searchName: string) {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const result = params.get(searchName);
  return result;
}
